import { DS_BREAKPOINT } from '@calm/evexia-design-tokens';
import { Stack, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { PropsWithChildren, ReactNode } from 'react';
import { GlobalLayoutContainer } from './styles';

const styleOuterPageContainer = {
    display: 'flex',
    justifyContent: 'center',
};
const styleInnerPageContainer = {
    width: '100%',
    maxWidth: DS_BREAKPOINT.ULTRA,
};

export const MaxWidthLayout = ({ children }: PropsWithChildren) => {
    return (
        <div style={styleOuterPageContainer}>
            <div style={styleInnerPageContainer}>{children}</div>
        </div>
    );
};

export interface GlobalLayoutProps {
    // Omit the 'px' unit label - it is applied for you
    rowGap?: number | string;
}

export const GlobalLayout = ({
    rowGap,
    children,
}: GlobalLayoutProps & PropsWithChildren) => {
    return (
        <GlobalLayoutContainer rowGap={rowGap}>
            {children}
        </GlobalLayoutContainer>
    );
};

const styleContainer = (maxWidth: number) => ({
    width: '100%',
    maxWidth: `min(${maxWidth}px, 100%)`,
    mx: 'auto',
});

/**
 * Columns
 * Will move these to design tokens when finalized
 */
export type LayoutColumns = 1 | 2 | 4 | 6 | 8 | 10 | 12;

export const gutterWidth = 24;
export const columnWidth = 93;

export function columnsToWidth(columns: LayoutColumns) {
    return columns * columnWidth + (columns - 1) * gutterWidth;
}

export const maxWidths: Record<LayoutColumns, number> = {
    1: columnsToWidth(1),
    2: columnsToWidth(2),
    4: columnsToWidth(4), // TODO Replace style values of 440 and 442 with this
    6: columnsToWidth(6),
    8: columnsToWidth(8),
    10: columnsToWidth(10),
    12: columnsToWidth(12),
};

/** End Columns */

/**
 * Creates an element which is contrained to a maximum width equal to a number of columns of a 1440px layout.
 *
 * @param {Object} props
 * @param {number} props.columns - Set max width equal to the width of this number of columns, within a 1440px grid
 */
export function MaxColumnsContainer({
    children,
    sx,
    id,
    columns, //test
}: {
    children?: ReactNode;
    id?: string;
    sx?: SxProps<Theme>;
    columns: LayoutColumns;
}) {
    const maxWidth = maxWidths[columns];

    return (
        <Stack sx={sxAppend(styleContainer(maxWidth), sx)} id={id}>
            {children}
        </Stack>
    );
}
